import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { EpisodeListComponent } from './features/episodes/episode-list.component';
import { EpisodeDetailComponent } from './features/episode-detail/episode-detail.component';
import { CategoryListComponent } from './features/categories/category-list.component';
import { AboutComponent } from './features/about/about.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'PodLab - Il podcast su scienza e tecnologia'
  },
  {
    path: 'episodi',
    component: EpisodeListComponent,
    data: { type: 'all' },
    title: 'Tutti gli episodi - PodLab'
  },
  {
    path: 'episodi/:slug',
    component: EpisodeDetailComponent,
    title: 'Episodio - PodLab'
  },
  {
    path: 'categorie',
    component: CategoryListComponent,
    title: 'Categorie - AI PodLab'
  },
  {
    path: 'about',
    component: AboutComponent,
    title: 'Chi Siamo - AI PodLab'
  },
  {
    path: 'categoria/:slug',
    component: EpisodeListComponent,
    data: { type: 'category' },
    title: 'Episodi per categoria - PodLab'
  },
  {
    path: 'tag/:slug',
    component: EpisodeListComponent,
    data: { type: 'tag' },
    title: 'Episodi per tag - PodLab'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
